/**
 * SEO & Accessibility Utilities for Himalayan Pansar Store
 */

export function generateDefaultProductAltText(product, imageIndex = 0, lang = 'ur') {
  if (!product || typeof product !== 'object') {
    return lang === 'en'
      ? 'Himalayan Pansar Store - 100% Pure Organic Herbal Products'
      : 'ہمالین پنسار سٹور - 100% خالص قدرتی دیسی جڑی بوٹیاں و علاج';
  }

  const nameUrdu = (typeof product.nameUrdu === 'string' ? product.nameUrdu : String(product.nameUrdu || '')).trim();
  const nameEn = (typeof product.nameEn === 'string' ? product.nameEn : String(product.nameEn || '')).trim();

  let title = '';
  if (nameUrdu && nameEn) {
    title = `${nameUrdu} (${nameEn})`;
  } else {
    title = nameUrdu || nameEn || 'دیسی جڑی بوٹی';
  }

  const isEn = lang === 'en';
  const descriptor = isEn
    ? '100% Pure Natural Organic Herbal Medicine'
    : '100% خالص قدرتی دیسی جڑی بوٹی و ہربل علاج';
  const storeName = isEn ? 'Himalayan Pansar Store' : 'ہمالین پنسار سٹور';

  const baseAlt = `${title} - ${descriptor} | ${storeName}`;

  if (imageIndex > 0) {
    return isEn 
      ? `${baseAlt} (View #${imageIndex + 1})`
      : `${baseAlt} (تصویر نمبر #${imageIndex + 1})`;
  }

  return baseAlt;
}

export function getProductAltText(product, imageIndex = 0, lang = 'ur') {
  try {
    if (!product || typeof product !== 'object') {
      return generateDefaultProductAltText(null, imageIndex, lang);
    }

    const rawCustom = product.imageAlt || product.altText || '';
    const customAlt = typeof rawCustom === 'string' ? rawCustom.trim() : String(rawCustom || '').trim();

    if (customAlt) {
      if (imageIndex > 0) {
        return lang === 'en'
          ? `${customAlt} (View #${imageIndex + 1})`
          : `${customAlt} (تصویر #${imageIndex + 1})`;
      }
      return customAlt;
    }

    return generateDefaultProductAltText(product, imageIndex, lang);
  } catch (err) {
    return 'ہمالین پنسار سٹور - خالص قدرتی دیسی جڑی بوٹی';
  }
}

export function updateDocumentSeo(seoData = {}) {
  if (typeof document === 'undefined' || !seoData || typeof seoData !== 'object') return;

  try {
    const {
      title,
      description,
      image,
      url,
      type = 'website'
    } = seoData;

    if (title && typeof title === 'string') {
      document.title = title;
    }

    const setMeta = (attr, key, content) => {
      if (!content || typeof content !== 'string') return;
      try {
        let elem = document.querySelector(`meta[${attr}="${key}"]`);
        if (!elem) {
          elem = document.createElement('meta');
          elem.setAttribute(attr, key);
          document.head.appendChild(elem);
        }
        elem.setAttribute('content', content);
      } catch (e) {}
    };

    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }

    if (title) {
      setMeta('property', 'og:title', title);
      setMeta('name', 'twitter:title', title);
    }

    if (image && typeof image === 'string') {
      setMeta('property', 'og:image', image);
      setMeta('name', 'twitter:image', image);
    }

    if (url && typeof url === 'string') {
      setMeta('property', 'og:url', url);
    }

    if (type && typeof type === 'string') {
      setMeta('property', 'og:type', type);
    }
  } catch (err) {}
}
